import axios from 'axios';

import cfac22 from '../cfac22';

export default function registerVists(uId, establishmentId, visitType) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      post(
        `${cfac22('API_HOST_V2')}/users/visits`,
        {
          payload: { establishmentId, visitType }
        },
        {
          headers: { 'Full-Url': window.location.href }, withCredentials: true
        }
      ).
      then((result) => {
        // console.log("RESULT_REGISTER_VISITS: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERROR_REGISTER_VISITS: ", error);
        return reject(error);
      });
    }).
    catch((error) => {
      //console.log("ERROR_TOKE:", error);
      reject(error);
    });
  });
}
